// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { XProductFilters } from "@guestsupply/XDL/types";
import { addToChainAfter, addToChainBefore, HandlerWithResult } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    DispatchSetProductFilters,
    ResetPage,
} from "@insite/client-framework/Store/Pages/ProductList/Handlers/RemoveProductFilters";

type HandlerType = HandlerWithResult<XProductFilters, XProductFilters>;

export const XngResetPage: HandlerType = props => {
    if (props.parameter.brandStandards?.length) {
        props.result.page = undefined;
    }
};
export const RemoveBrandStandardsFilters: HandlerType = props => {
    props.result.brandStandards = props.result.brandStandards?.filter(
        x => !props.parameter.brandStandards?.find(y => y === x),
    );
    if (props.result.brandStandards?.length === 0) {
        props.result.brandStandards = undefined;
    }
};

export const RemoveAvendraPricingFilter: HandlerType = ({ result, parameter: { isAvendraPricing } }) => {
    if (isAvendraPricing !== undefined) {
        result.isAvendraPricing = undefined;
    }
};

addToChainAfter(chain, ResetPage, XngResetPage);
addToChainBefore(chain, DispatchSetProductFilters, RemoveBrandStandardsFilters);
addToChainBefore(chain, DispatchSetProductFilters, RemoveAvendraPricingFilter);
